<div class="grid">
  <div class="col-6">
    <p-dropdown
    class="custom-dropdown"
      [options]="quarterConfigOptions"
      optionLabel="label"
      optionValue="value"
      (onChange)="setUpConfig()"
      [(ngModel)]="selectedConfigOption"
    >

    </p-dropdown>
  </div>
  <div class="col-12 flex justify-content-start">
    <p-table
    style="width: 100%;"
      class="custom-table stock-table"
      [loading]="loading"
      [value]="quarterNameConfigs"
    >
      <ng-template pTemplate="header">
        <tr>
          <th class="cell-style">
            {{'QuarterNameConfigForm.KeyHeader' | translate}}
          </th>
          <th class="cell-style">
            {{'QuarterNameConfigForm.ValueHeader' | translate}}
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-config>
        <tr>
          <td class="cell-style">
            {{config.configValue}}
          </td>
          <td class="cell-style">
            <input
            pInputText
            class="custom-input"
            type="text"
            [(ngModel)]="config.configName"
            [maxlength]="100"
            />
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="2" class="cell-style">{{'QuarterNameConfigForm.EmptyResultsText' | translate}}</td>
        </tr>
    </ng-template>
    </p-table>
  </div>
  <div class="col-12 flex justify-content-end">
    <p-button
    [loading]="loading"
    (click)="create()"
    styleClass="p-button-text p-button-primary p-button-sm"
    label=" {{'QuarterNameConfigForm.ButtonLabel' | translate}}"
    >
    </p-button>
  </div>
</div>
